import { Box, Typography } from '@mui/material';

export function NoMobileSupport() {
    return (
        <Box sx={{display: {xs: 'block', sm: 'none', md: 'none', lg: 'none'}, p: 5, alignItems: "center", justifyContent: "center"}}>
            <div style={{ textAlign: 'center'}}>
                <Typography variant="h6" color="var(--brand-main)">
                    This website is currently optimized for wider screens.
                </Typography>
                <Typography variant="body1" color="var(--brand-text-secondary)">
                    Please increase your window size for the best experience.
                </Typography>
            </div>
        </Box>
    )
}